import React from "react";
import EmptyRow from "../../../general/table/emptyRow";
import TableLoader from "../../../general/table/tableLoader";
import FavoriteParaclinicTableRowItem from "./favoriteParaclinicsTable_rowItem";

type FavoriteParaclinicsTableProps = {
  dataList?: any;
  dataListTitles: string[];
  isRequesting: boolean
}

const FavoriteParaclinicsTable = ({
  dataList,
  dataListTitles,
  isRequesting
}: FavoriteParaclinicsTableProps) => {
  const _dataListTitles = dataListTitles.map((item, i) => <td key={i}>{item}</td>),
    _dataList = dataList && dataList?.length > 0 && dataList?.map((item: any, i: number) => {
      return <FavoriteParaclinicTableRowItem item={item} key={i}/>
    });

  return (
    <table>
      <thead>
      <tr>
        {_dataListTitles}
      </tr>
      </thead>
      <tbody>
      {isRequesting ?
        <TableLoader colSpan={dataListTitles.length}/> :
        _dataList ? _dataList : <EmptyRow colSpan={dataListTitles.length} content={''}/>
      }
      </tbody>
    </table>
  )
}

export default FavoriteParaclinicsTable;
